import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const userName = (user) => {
  if (!user) return '-'
  return user.tradingName ||
    [user.firstName, user.lastName].filter(Boolean).join(' ') ||
    user.email ||
    '-'
}

export const formatDate = (value) => {
  if (!value) return '-'
  const date = new Date(value)
  if (isNaN(date.getTime())) return '-'
  return date.toLocaleDateString('en-AU')
}

// Small read-only star row
export const Stars = ({ value }) => {
  const rounded = Math.round(Number(value) || 0)
  return (
    <span className='survey-stars'>
      {[1, 2, 3, 4, 5].map(index => (
        <FontAwesomeIcon
          key={index}
          icon='star'
          className={index <= rounded ? 'star filled' : 'star'}
        />
      ))}
      <span className='rating-number'>{Number(value || 0).toFixed(2)}</span>
    </span>
  )
}
